module.exports = __webpack_public_path__ + "ed837336a1684d5a410965bffb6a96a8.jpg";


//////////////////
// WEBPACK FOOTER
// ./app/containers/StaticPage/ComeBack/assets/sec-4/ck.jpg
// module id = ./app/containers/StaticPage/ComeBack/assets/sec-4/ck.jpg
// module chunks = 40